import { useMutation } from '@tanstack/react-query';

import { apiClient } from '@/lib/apiClient';
import type { MutationOptions } from '@/lib/reactQuery';

export interface CancelAppointmentBody {
  appointmentId: string;
  studentId: number;
  applyToFollowingAppointments: boolean;
  isLateCancel: boolean;
}

export const cancelAppointment = async (data: CancelAppointmentBody): Promise<void> => {
  await apiClient.post('/v1/scheduling/cancel-appointment', data);
};

interface UseCancelAppointmentOptions {
  options?: MutationOptions<void, CancelAppointmentBody>;
}

export const useCancelAppointment = ({ options }: UseCancelAppointmentOptions = {}) =>
  useMutation({
    mutationKey: ['cancelAppointment'],
    mutationFn: cancelAppointment,
    ...options,
  });
